const initialState = {
  eventList: [],
  filters: {
    searchText: '',
    page_no: 1,
    page_size: 10,
    city: '',
    status: 'ALL',
  },
  totalPages: 1,
};

export default (state = initialState, action) => {
  const { type, data } = action;

  switch(type) {
  case 'ADMIN_PRIMARY_LIVE_AND_UPCOMING_EVENT_LIST:DATA:SET':
    return {
      ...state,
      eventList: data?.data,
      totalPages: data?.totalPages,
    };
  case 'ADMIN_PRIMARY_LIVE_AND_UPCOMING_EVENT_LIST:FILTERS:SET':
    return {
      ...state,
      filters: data,
    };
  default:
    return state;
  }
}